import { createFileRoute, Link, Outlet, useLocation } from "@tanstack/react-router";
import { supabase } from "@/integrations/supabase/client";
import { useSession } from "@/hooks/use-session";

export const Route = createFileRoute("/_authenticated/admin")({
  head: () => ({
    meta: [
      { title: "Panel Admin | Mine Class" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: AdminLayout,
});

function AdminLayout() {
  const { profile } = useSession();
  const { pathname } = useLocation();

  const tabs: { to: string; label: string }[] = [
    { to: "/admin", label: "Dashboard" },
    
    { to: "/admin/leads", label: "Leads" },
    { to: "/admin/formularios", label: "Formularios" },

    { to: "/admin/chatbot", label: "Chatbot" },
    { to: "/admin/newsletter", label: "Newsletter" },
    { to: "/admin/contenidos", label: "Subir contenido" },
    { to: "/admin/noticias", label: "Noticias" },
    { to: "/admin/editoriales", label: "Editoriales" },
    { to: "/admin/hero", label: "Hero (carrusel)" },
    { to: "/admin/equipo", label: "Equipo" },
    { to: "/admin/cursos", label: "Cursos" },
    { to: "/admin/linkedin", label: "LinkedIn" },
    { to: "/admin/settings", label: "Configuración" },
  ];

  async function signOut() {
    await supabase.auth.signOut();
    window.location.href = "/";
  }

  return (
    <div className="min-h-screen bg-[var(--color-surface-container-low)]">
      <header className="bg-[var(--color-brand-purple)] text-white">
        <div className="max-w-container-max mx-auto px-margin-desktop py-4 flex items-center justify-between">
          <div>
            <div className="text-xs uppercase tracking-widest text-white/60">Mine Class</div>
            <h1 className="text-xl font-bold">Panel administrativo</h1>
          </div>
          <div className="flex items-center gap-4">
            <span className="text-sm text-white/80">{profile?.email}</span>
            <Link to="/home" className="text-sm underline">Ver sitio</Link>
            <button
              onClick={signOut}
              className="px-3 py-1.5 bg-[var(--color-brand-coral)] text-white text-sm font-bold uppercase tracking-wider hover:brightness-110"
            >
              Salir
            </button>
          </div>
        </div>
        <nav className="max-w-container-max mx-auto px-margin-desktop flex gap-1 border-t border-white/10 overflow-x-auto">
          {tabs.map((t) => {
              const active = t.to === "/admin" ? pathname === "/admin" : pathname.startsWith(t.to);
              return (
                <Link
                  key={t.to}
                  to={t.to}
                  className={`px-4 py-3 text-sm font-semibold whitespace-nowrap ${
                    active ? "bg-white text-[var(--color-brand-purple)]" : "text-white/80 hover:text-white"
                  }`}
                >
                  {t.label}
                </Link>
              );
            })}
        </nav>
      </header>

      <main className="max-w-container-max mx-auto px-margin-desktop py-8">
        <Outlet />
      </main>
    </div>
  );
}
